<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section bg-chsc-raw">
        <UiContainer>
            <header class="global-text">
                <h2>{{ blok?.title }}</h2>
            </header>
            <div class="mt-20">
                <div class="grid grid-cols-12 gap-y-20 gap-x-6 max-[641px]:gap-x-0">
                    <div
                        v-for="item in blok?.members"
                        :key="item._uid"
                        class="col-span-3 max-[769px]:col-span-6 max-[641px]:col-span-12"
                    >
                        <TeamItem
                            :image="item.image"
                            :name="item.name"
                            :description="item.description"
                        />
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
